var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDashboardLayout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2H4C2.897 2 2 2.897 2 4V11C2 12.103 2.897 13 4 13H9C10.103 13 11 12.103 11 11V4C11 2.897 10.103 2 9 2ZM20 2H15C13.897 2 13 2.897 13 4V7C13 8.103 13.897 9 15 9H20C21.103 9 22 8.103 22 7V4C22 2.897 21.103 2 20 2ZM9 15H4C2.897 15 2 15.897 2 17V20C2 21.103 2.897 22 4 22H9C10.103 22 11 21.103 11 20V17C11 15.897 10.103 15 9 15ZM20 11H15C13.897 11 13 11.897 13 13V20C13 21.103 13.897 22 15 22H20C21.103 22 22 21.103 22 20V13C22 11.897 21.103 11 20 11Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboardLayout);
export default __webpack_public_path__ + "static/media/ic_dashboard_layout.32663ead54954662f4a30c2ccbff44c7.svg";
export { ForwardRef as ReactComponent };